export default __webpack_public_path__ + "static/media/08.4151624f.jpg";